// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ol[data-v-059e853c]{list-style:decimal}li[data-v-059e853c],p[data-v-059e853c]{margin-bottom:1.5rem}.active[data-v-059e853c]:after{content:\"\";width:.25rem;height:100%;position:absolute;right:0;top:0;bottom:0;--bg-opacity:1;background-color:#4372c8;background-color:rgba(67,114,200,var(--bg-opacity));border-radius:9999px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
